<template>
  <div class="div">
    <div class="text">
      <div class="img"></div>
      <span class="yun">在线统计</span>
    </div>
    <div ref="Polyline" :style="{ width: '100%', height: '80%' }"></div>
  </div>
</template>

<script>
export default {
  props: {
    chartObjRight3: {
      type: Object,
      default: function () {
        return {
          timeList: [],
          dataList: [[], [], []]
        };
      }
    }
  },
  watch: {
    chartObjRight3: {
      handler (data) {
        this.renderChart(data.timeList, data.dataList);
      },
      deep: true
    }
  },
  data () {
    return {
      mychart: null,
      option: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(0, 255, 233,0)"
                  },
                  {
                    offset: 0.5,
                    color: "rgba(255, 255, 255,1)"
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 255, 233,0)"
                  }
                ],
                global: false
              }
            }
          }
        },
        legend: {
          top: 15,
          data: ["新增运力", "新增的运力在线数", "新增的运力执行订单数"],
          textStyle: {
            color: "#fff",
            fontSize: 12
          }
        },
        grid: {
          top: "20%",
          left: "10%",
          right: "10%",
          bottom: "20%"
          // containLabel: true
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: true
          },
          splitArea: {
            // show: false,
            color: "#f00",
            lineStyle: {
              show: false,
              color: "#f00"
            }
          },
          axisLabel: {
            color: "#fff"
          },
          splitLine: {
            show: false
          },
          boundaryGap: false,
          data: []
        },

        yAxis: [
          {
            type: "value",
            min: 0,
            // max: 140,
            splitNumber: 4,
            splitLine: {
              show: false,
              lineStyle: {
                color: "rgba(255,255,255,0.1)"
              }
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              show: false,
              margin: 20,
              textStyle: {
                color: "#d1e6eb"
              }
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: [
          {
            name: "新增运力",
            type: "line",
            // smooth: true, //是否平滑
            showAllSymbol: true,
            // symbol: 'image://./static/images/guang-circle.png',
            symbol: "circle",
            symbolSize: 10,
            lineStyle: {
              normal: {
                color: "#45b97c",
              }
            },
            label: {
              show: false
            },
            itemStyle: {
              color: "#45b97c",
              borderColor: "#fff",
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2
            },
            tooltip: {
              show: false
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(69,185,124,0.3)"
                    },
                    {
                      offset: 1,
                      color: "rgba(69,185,124,0)"
                    }
                  ],
                  false
                ),
                shadowColor: "rgba(69,185,124, 0.9)",
                shadowBlur: 20
              }
            },
            data: []
          },
          {
            name: "新增的运力在线数",
            type: "line",
            // smooth: true, //是否平滑
            showAllSymbol: true,
            // symbol: 'image://./static/images/guang-circle.png',
            symbol: "circle",
            symbolSize: 10,
            lineStyle: {
              normal: {
                color: "#ffd400",
              }
            },
            label: {
              show: false
            },
            itemStyle: {
              color: "#ffd400",
            },
            tooltip: {
              show: false
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(255,212,0,0.3)"
                    },
                    {
                      offset: 1,
                      color: "rgba(255,212,0,0)"
                    }
                  ],
                  false
                ),
                shadowColor: "rgba(255,212,0, 0.9)",
                shadowBlur: 10
              }
            },
            data: []
          },
          {
            name: "新增的运力执行订单数",
            type: "line",
            // smooth: true, //是否平滑
            showAllSymbol: true,
            // symbol: 'image://./static/images/guang-circle.png',
            symbol: "circle",
            symbolSize: 10,
            lineStyle: {
              normal: {
                color: "#009ad6",
              }
            },
            label: {
              show: false
            },
            itemStyle: {
              color: "#009ad6",
              borderColor: "#fff",
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2
            },
            tooltip: {
              show: false
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(0,154,214,0.3)"
                    },
                    {
                      offset: 1,
                      color: "rgba(0,154,214,0)"
                    }
                  ],
                  false
                ),
                shadowColor: "rgba(0,154,214, 0.9)",
                shadowBlur: 10
              }
            },
            data: []
          }
        ]
      }
    };
  },
  mounted () {
    this.Polyline();
  },
  methods: {
    Polyline () {
      this.mychart = this.$echarts.init(this.$refs.Polyline);
      // this.renderChart(this.timeList, this.dataList);
    },
    renderChart (xAxisData, seriesDataList) {
      this.option.xAxis.data = xAxisData;
      for (let i = 0; i < seriesDataList.length; i++) {
        this.option.series[i].data = seriesDataList[i];
      }
      this.mychart.setOption(this.option);
    }
  }
};
</script>

<style scoped>
.div {
  width: 100%;
  height: 32%;
  margin: 1% 0;
  background-image: url('../assets/img/CapacityPolyline/右3-bg.png');
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: 100% 100%;
}
.div .text {
  width: 100%;
  height: 15%;
  padding-top: 10px;
  display: flex;
  background-image: url('../assets/img/CapacityPolyline/右3line.png');
  background-repeat: no-repeat;
  background-position: 50% 100%;
  background-size: 90%;
  position: relative;
}
.div .text .img {
  width: 40px;
  height: 40px;
  background-image: url('../assets/img/CapacityPolyline/tongji.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 110%;
  position: absolute;
  top: 39%;
  left: 2.5%;
}
.div .text .yun {
  margin-top: 4%;
  margin-left: 11%;
  font-family: 'PingFangSC-Regular';
  font-size: 18px;
  color: aliceblue;
}
</style>



// WEBPACK FOOTER //
// src/components/CapacityPolyline.vue